import * as playerAction from '../../js/playeractions/playeractions';
import { initSegment } from '../../services/segmentHandlers/initSegment';
import { handleLiveStreamControls } from '../../services/liveStreamHandlers/handleLiveStreamControls';
import { removeEventListeners } from '../../services/eventListenerHandlers/removeEventListeners';
import { NpoPlayerEvent } from '../../types/events';
import { updateClassFromElementByQuery } from '../../js/utilities/utilities.element';
export function handleStreamOptions(playerContext) {
    const { streamObject, uiManager } = playerContext.npoplayer;
    if (!streamObject || !uiManager)
        return;
    removeEventListeners(playerContext);
    initializeFragment(playerContext);
    handleStartOffset(playerContext);
    updateStreamClasses(playerContext);
    const isAutoplayEnabled = getAutoplayStatus(playerContext);
    if (isAutoplayEnabled) {
        setupAutoplay(playerContext);
    }
}
export function initializeFragment(playerContext) {
    const { streamObject, streamOptions } = playerContext.npoplayer;
    initSegment(playerContext, {
        segment: streamObject.segment,
        fragment: streamOptions?.fragments
    });
}
export function handleStartOffset(playerContext) {
    const streamOptions = playerContext.npoplayer.streamOptions;
    if (streamOptions?.startOffset) {
        playerAction.handleStartOffset(playerContext, streamOptions.startOffset);
    }
}
export function updateStreamClasses(playerContext) {
    const { streamObject, container } = playerContext.npoplayer;
    const containerClassString = '.bmpui-ui-uicontainer';
    const playerContainer = container;
    const queries = [
        {
            container: playerContainer,
            query: containerClassString,
            className: 'livestream-no-dvr',
            condition: !!(streamObject.stream.isLiveStream && !streamObject.stream.hasDvrWindow)
        },
        {
            container: playerContainer,
            query: containerClassString,
            className: 'audio-only',
            condition: !!(streamObject.stream.avType === 'aod' || streamObject.stream.avType === 'audio')
        },
        {
            container: playerContainer,
            query: '.bitmovinplayer-poster',
            className: 'audio-only',
            condition: !!(streamObject.stream.avType === 'aod' || streamObject.stream.avType === 'audio')
        }
    ];
    for (const query of queries)
        updateClassFromElementByQuery(query);
    if (streamObject.stream.isLiveStream && streamObject.stream.hasDvrWindow) {
        handleLiveStreamControls(playerContext);
    }
}
function getAutoplayStatus(playerContext) {
    return (playerContext.npoplayer.streamOptions?.autoplay ?? playerContext.player.getConfig()?.playback?.autoplay ?? false);
}
export function setupAutoplay(playerContext) {
    const player = playerContext.player;
    const handleAutoPlay = () => {
        doAutoPlay().catch((error) => {
            console.error('Error attempting to autoplay:', error);
        });
    };
    const doAutoPlay = async () => {
        player.off(NpoPlayerEvent.SourceLoaded, handleAutoPlay);
        await player.play();
    };
    player.on(NpoPlayerEvent.SourceLoaded, handleAutoPlay);
}
